/**
 * Renders the line total shown inside the add to cart button.
 *
 * `price` is the unit price in cents so the multiplication stays exact; the
 * division to a currency amount happens once, at format time.
 */
class AtcPrice extends HTMLElement {
  static observedAttributes = ["price", "quantity", "currency"];

  attributeChangedCallback() {
    this.render();
  }

  render() {
    if (!Number.isFinite(this.price)) return;

    this.textContent = window.formatMoney(
      (this.price * this.quantity) / 100,
      false,
      this.currency,
    );
  }

  get price() {
    return parseInt(this.getAttribute("price"), 10);
  }

  get quantity() {
    return parseInt(this.getAttribute("quantity"), 10) || 1;
  }

  get currency() {
    return this.getAttribute("currency") || "USD";
  }
}

if (!customElements.get("atc-price")) {
  customElements.define("atc-price", AtcPrice);
}
